import ReactMarkdown from "react-markdown"

export const Markdown = ({
	children,
	specificComponents = {},
	...rest
}) => {
	return (
		<ReactMarkdown
			components={{
				p: ({ children }) => <p>{children}</p>,
				a: ({ href, children }) => (
					<a className="underline" target="_blank" rel="noopener noreferrer" href={href}>
						{children}
					</a>
				),
				strong: ({ children }) => <span className="font-bold">{children}</span>,
				...specificComponents,
			}}
			{...rest}
		>
			{children}
		</ReactMarkdown>
	)
}